module.exports = __webpack_public_path__ + "static/media/Meds.525f9416.svg";